// JsFromRoutes CacheKey c4f01203c3a4f1936849374c6aad0afc
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/admin/prospects/:prospect_id/census/:id'),
}
